import { getUserIdFromToken } from "../auth/authUtils";
import { Address } from "../API/Address/ViewAllAddedAddressByUserAsync";

export const updateLocalStorageAddressData = (
  addressId: number,
  updatedAddressData: Partial<Address>
) => {
  const token = localStorage.getItem('token');
  if (!token) return;
  const userId = getUserIdFromToken();
  const storageKey = `recentSearch_${userId}`;
  const storedHistory = localStorage.getItem(storageKey);
  
  if (storedHistory) {
    try {
      let history = JSON.parse(storedHistory);
      history = history.map((item: any) => {
        if (Array.isArray(item.results)) {
          item.results = item.results.map((addr: any) => {
            if (Number(addr.id) === addressId) {
              return { ...addr, ...updatedAddressData };
            }
            return addr;
          });
        } 
        else if (item.results && Array.isArray(item.results.addresses)) {
          item.results.addresses = item.results.addresses.map((addr: any) => {
            if (Number(addr.id) === addressId) {
              return { ...addr, ...updatedAddressData };
            }
            return addr;
          });
        }
        return item;
      });
      localStorage.setItem(storageKey, JSON.stringify(history));
    } catch (error) {
      console.error("Error updating local storage address data:", error);
    }
  }
};
